module.exports = __webpack_public_path__ + "static/media/companion-img-003.4852d76a.jpg";